import DG from '2gis-maps';
import cn from 'classnames';

const ICON_CLASS = {
  ACTIVE: 'mos-active',
  MARKER_NATIVE: 'leaflet-marker-icon',
  MARKER_COMMON: 'GisMap__marker',
  MARKER_PLACE: 'GisMap__marker--place',
  MARKER_ACTIVE: 'GisMap__marker--active',
  MARKER_CLUSTER: 'GisMap__marker--cluster',
  MARKER_COUNT: 'GisMap__marker--count',
};

const MAX_MARKER_COUNT = 99;

const iconGenerator = {
  generatePlace: (
    count,
    selected,
    active,
    countVisible,
    customIconClass = ''
  ) => {
    const options = {
      className: cn(ICON_CLASS.MARKER_COMMON, ICON_CLASS.MARKER_PLACE, {
        [ICON_CLASS.MARKER_ACTIVE]: selected,
        [ICON_CLASS.ACTIVE]: active,
        [customIconClass]: !!customIconClass,
      }),
      iconSize: [42, 47],
    };

    if (countVisible && count > 1) {
      const markerCount = Math.min(count, MAX_MARKER_COUNT);

      Object.assign(options, {
        html: `<div class="${ICON_CLASS.MARKER_COUNT}">${markerCount}</div>`,
      });
    }
    return DG.divIcon(options);
  },

  generateCluster: () =>
    DG.divIcon({
      className: cn(
        ICON_CLASS.MARKER_COMMON,
        ICON_CLASS.MARKER_CLUSTER,
        ICON_CLASS.ACTIVE
      ),
      iconSize: [30, 30],
    }),
};

export { iconGenerator, ICON_CLASS };
